export default {"src":"/_next/static/media/unicorn.fc59e5c2.svg","height":295,"width":334,"blurWidth":0,"blurHeight":0};